export const enum URLParameters {
  Flow = 'flow',
}
